<template>
  <!-- Header Start -->
  <div id="bgCarousel" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
      <!-- Slide 1 -->
      <div class="carousel-item active">
        <div
          class="carousel-background"
          style="background-image: url('/assets/images/Wasiyyah.jpeg')"
        ></div>
      </div>

      <div class="carousel-item">
        <img
          src="@/assets/images/Wasiyyah2.jpeg"
          class="d-block w-100"
          alt="..."
        />
      </div>

      <!-- Add more carousel-item divs for additional slides if needed -->
    </div>
    <!-- Caption placed once, outside .carousel-inner -->

    <div class="carousel-caption position-absolute top-50 start-50 translate-middle text-center" style="z-index: 10">
      <h1 class="display-4 text-white">{{ $t("Welcome to Wasiyyat") }}</h1>
      <p class="lead text-white">{{ $t('Your Guide to Creating a Wasiyyat') }}</p>
      <a class="btn btn-success" href="https://app.wasiyyat.com" target="_blank">{{ $t('Create Now') }}</a>
    </div>

    <!-- Carousel Controls -->
    <button
      class="carousel-control-prev"
      type="button"
      data-bs-target="#bgCarousel"
      data-bs-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      data-bs-target="#bgCarousel"
      data-bs-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
  <div class="row">
    <div class="col-md-8 m-auto">
      <h1
        style="
          color: #077747;
          font-family: 'Poppins', sans-serif;
          justify-content: left;
          margin-top: 50px;
        "
      >
        {{ $t("H") }}
      </h1>
      <p style="font-family: 'Poppins', sans-serif; text-align: justify">
        <sapn style="font-size: 30px; color: #077747">{{ $t("W") }}</sapn>
        {{ $t("Wasiyyah") }}
        <br />
        <br />
        {{ $t("islamic") }}
      </p>
    </div>
    <div class="col-md-12 mt-5">
      <TripleSlider :slides="sliderData" />
    </div>
  </div>

  <Calculation v-if="showAllSections" />
  <AboutUs v-if="showAllSections" />
  <FAQ v-if="showAllSections" />
  <ContactUs v-if="showAllSections" />

  <div class="row wasiyyah-app">
    <hr />
    <div class="col-md-10 m-auto">
      <a
        href="https://play.google.com/store/apps/details?id=com.ihadis.dua"
        target="_blank "
      >
        <img
          src="@/assets/images/QRapps.jpeg"
          alt=""
          sizes=""
          class="img-fluid"
      /></a>
    </div>
  </div>
</template>
<script>
import Calculation from "./Calculation.vue";
// import AboutUs from './AboutUs.vue';
import ContactUs from "./ContactUs.vue";
import FAQ from "./FAQ.vue";
import TripleSlider from "./TripleSlider.vue";
// import apiRepository from '@/services/apiRepository';
// import axios from "axios";
export default {
  name: "DashBoard",
  components: {
    // PieChart: Pie,
    Calculation,
    // AboutUs,
    ContactUs,
    FAQ,
    TripleSlider,
  },
  data() {
    return {
      sliderData: [],
      relativeData: [],
      selectedRelatives: {},
      relationSelect: "",
    };
  },
  computed: {
    showAllSections() {
      // Use route meta property to determine if all sections should be shown
      return this.$route.meta.showAllSections;
    },
  },
  mounted() {
    fetch("/assets/videos.json")
      .then((response) => response.json())
      .then((data) => {
        this.sliderData = data;
      })
      .catch((error) => {
        console.error("Error fetching video data:", error);
      });
  },
  methods: {
    logout() {
      localStorage.removeItem("auth"); // Remove auth state
      this.$router.push("/login"); // Redirect to login page
    },
  },
};
</script>
